module.exports = __webpack_public_path__ + "img/logo-light.52a8cdf2.png";